<template>
	<transition name="fade" mode="out-in">
	<div>
		<h2>Awards</h2>
		<ul>
			<li v-for="award in awards" :key="award.id">
				{{ award.name }} - Requires {{ award.points }} points
			</li>
		</ul>
	</div>
	</transition>
</template>

<script>
export default {
	name: 'AwardsPage',
	data() {
		return {
			awards: [
				{ id: 1, name: 'Bronze Medal', points: 50 },
				{ id: 2, name: 'Silver Medal', points: 100 },
				{ id: 3, name: 'Gold Medal', points: 150 }
			]
		};
	}
};
</script>

<style>
/* Add specific styles for Awards component */
</style>